module.exports = __webpack_public_path__ + "img/05_bullets.91be487c.png";